var NumberInput = {
    props: {
        value: [String, Number],
        max: Number,
        min: Number
    },
    template: `<input type="number" v-model="displayValue" @blur="isInputActive = false" @focus="isInputActive = true" />`,
    data: function () {
        return {
            isInputActive: false
        }
    },
    computed: {
        displayValue: {
            get: function () {
                if (this.isInputActive) {
                    return this.value.toString()
                } else {
                    return this.value.toFixed(0)
                }
            },
            set: function (modifiedValue) {
                let newValue = parseFloat(modifiedValue)
                if (isNaN(newValue) || newValue > this.max || newValue < this.min) {
                    newValue = ((this.max + this.min) / 2).toFixed(0)
                }
                this.$emit('input', newValue)
            }
        }
    }
}
module.exports = NumberInput